import { trpcReactClient } from '~/app/_trpc/trpc-react-client.ts'

export function useRefetchBuilder() {
  const _utils = trpcReactClient.useUtils()
  const promises: (false | Promise<void>)[] = []

  const refetchBuilder = {
    include: (
      input: (utils: typeof _utils) => false | Promise<void>,
      options?: { disabled?: boolean }
    ) => {
      if (options?.disabled) {
        return refetchBuilder
      }

      promises.push(input(_utils))

      return refetchBuilder
    },
    fetch: async () => {
      await Promise.all(promises)
    },
  }

  return refetchBuilder
}
